import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { headerlogo } from '../MediaConstants/Index';
import PersonIcon from '@mui/icons-material/Person';

import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { GetSiteSettingsApi } from '../Redux/Auth/Auth_Action';

const Header = () => {
    const getUserProfileRedux = useSelector((state) => state?.Auth);
    // const state = useSelector((state) => state.Auth);
    const dispatch = useDispatch();
    const [siteData, setSiteData] = useState(null);

    const getSiteSetting = () => {
        dispatch(GetSiteSettingsApi())
            .then((res) => {
                setSiteData(res?.data?.response?.data[0])
            })
            .catch((e) => {
                console.log(e);
            })
    }

    useEffect(() => {
        getSiteSetting();
    }, [])

    console.log(getUserProfileRedux, 'pzzzzzzzzzzzzzzzzzzzzzzzzz')

    return (
        <div className='header_comp'>
            <header id="header">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-2">
                            <div className="logo-wrapper">
                                <Link to="/">
                                    <img src={siteData?.media_url} className="img-fluid ftr-logoooooooo" alt="" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="navbar navbar-wrapper">
                                <ul>
                                    <li className="nav-item">
                                        <Link to="/" className="navlink">Home</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/about" className="navlink">About</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/menu" className="navlink">Menu</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/gallery" className="navlink">Gallery</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/contact" className="navlink">Contact Us</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/truck" className="navlink">Truck Cleanliness</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/profile" className="navlink">
                                            {(getUserProfileRedux.token) ?
                                                <img className='profile_image_headers' src={getUserProfileRedux?.user?.profile_picture} alt="profile picture"></img>
                                                :
                                                <PersonIcon />
                                            }
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="header-btn">
                                <Link to="/bookevent" className="btn">Book Event Instantly</Link>
                                {/* <Link to="/ondemand" className="btn demand">On demand</Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}

export default Header;